angular.module('dpw.directives')
    .component('dpwCategoryNav', {
        bindings: {
            category: '<'
        },
        templateUrl: 'dpw-category-nav.html',
        controller: [function () {
            var self = this;

            self.categories = [
                {id: 'office', label: RCDPW.RCProductName, href: '/'},
                {id: 'engage', label: 'engage', href: '/engage/api-products'}
            ];

            self.$onInit = function () {
                self.categories.forEach(function (item) {
                    item.active = item.id === self.category;
                });
            };
        }]
    });

